// 공지사항 필터 — 공용 SegmentedControl 사용 (TASK-02-A)
import { SegmentedControl } from '@/components/ui/SegmentedControl';
import type { AnnouncementTranslations, FilterType } from './types';

interface AnnouncementFilterTabsProps {
  selectedFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  translations: AnnouncementTranslations;
}

export function AnnouncementFilterTabs({
  selectedFilter,
  onFilterChange,
  translations,
}: AnnouncementFilterTabsProps) {
  const options = [
    { id: 'all', label: translations.all },
    { id: 'system', label: translations.system },
    { id: 'event', label: translations.event },
    { id: 'update', label: translations.update },
  ];

  return (
    <div className="bg-background px-4 py-3 shadow-sm sticky top-[50px] z-40">
      <SegmentedControl
        options={options}
        value={selectedFilter}
        onValueChange={(v) => onFilterChange(v as FilterType)}
        className="w-full"
        itemClassName="flex-1 px-4 text-[13px] font-bold"
        ariaLabel={translations.all}
      />
    </div>
  );
}
